import React from 'react'

const Status = () => {
  return (
    <div style={{
      backgroundColor: '#E8F7EC',
      color: '#67C97E',
      padding: '0.5rem',
      borderRadius: '0.5rem',
      marginBottom: '8px',
      textTransform: 'uppercase',
      fontSize: '12px',
      fontWeight: '600',
    }}>concluído</div>
  )
}

export default Status
